import React, { useState } from "react"
import { Button, Card, CardBody, Table } from "reactstrap"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"

import Paginations from "components/Common/Pagination"
import NoDataAvailable from "components/Shared/NoDataAvailable"
import DeleteModal from "components/Common/DeleteModal"
import { deleteCatering } from "store/actions/cateringAction"
import { showAlert } from "store/reducers/alertReducer"
import AddEditCatering from "./UploadNationalIdModal"
import { Check } from "lucide-react"
import { allowSigningContractsForBatch } from "store/actions/contractsAction"
import { useNavigate } from "react-router-dom"

const headers = [
  "S. No.",
  "Name",
  "Number of contracts",
  "Exported By",
  "Exported Date",
  "Imported",
  "Action",
]

const ExportsDatatable = ({
  currentPage,
  totalPages,
  totalCount,
  onPageChange,
  loading,
  data = [],
  trigger,
  payload,
  permissions,
  showAll,
}) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)

  const handleAllowSigning = uuid => {
    setIsLoading(true)
    dispatch(allowSigningContractsForBatch({ contract_batch_uuid: uuid }))
      .then(action => {
        const { statusCode, success, message } = action?.payload
        if (statusCode === 200 && success) {
          dispatch(showAlert({ text: message, type: "success" }))
          trigger()
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
        setIsLoading(false)
      })
      .catch(error => {})
  }

  return (
    <>
      <Card className="user_personal_info theme_card overflow-x-auto">
        <CardBody>
          <div className="table-responsive">
            <Table className="table mb-0">
              <thead className="table-light full_th">
                <tr>
                  {headers.map((item, index) => (
                    <th key={index}>{t(item)}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {!loading && data.length === 0
                  ? null
                  : data.map((item, index) => (
                      <tr key={index}>
                        <th scope="row">
                          {(currentPage - 1) * (payload.limit || 50) +
                            index +
                            1}
                        </th>
                        <td
                          onClick={() => {
                            if (
                              showAll ||
                              permissions.includes("can_view_batch_candidates")
                            ) {
                              navigate(
                                `/contracts/participants?uuid=${item.uuid}`
                              )
                            }
                          }}
                          className="text-decoration-underline cursor-pointer text-primary"
                        >
                          {language === "en" ? item.name : item.name_ar}
                        </td>
                        <td>{item.contracts_count}</td>
                        <td>{item.exported_by}</td>
                        <td>{item.created_at}</td>
                        <td
                          onClick={() => {
                            if (item.imported_from !== "manually")
                              window.open(item.imported_from, "_blank")
                          }}
                          className={`${
                            item.imported_from !== "manually"
                              ? "text-decoration-underline cursor-pointer text-primary"
                              : ""
                          }`}
                        >
                          {item.imported_from !== "manually"
                            ? t("View File")
                            : t("Manually")}
                        </td>
                        <td
                          title={t("Allow the candidates to sign the contract")}
                        >
                          {item.status === 0 &&
                            (showAll ||
                              permissions.includes(
                                "can_allow_single_signing_of_contract"
                              )) && (
                              <Button
                                onClick={() => handleAllowSigning(item.uuid)}
                                disabled={isLoading}
                                color="primary"
                              >
                                <Check size={12} />
                              </Button>
                            )}
                        </td>
                      </tr>
                    ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
      {!loading && data.length === 0 && <NoDataAvailable />}

      {!loading && data.length > 0 && (
        <Paginations
          currentPage={currentPage}
          totalPages={totalPages}
          totalCount={totalCount}
          onPageChange={onPageChange}
        />
      )}
      {/* <DeleteModal
        show={showDeleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={() => {
          setSelectedCatering(null)
          setShowDeleteModal(false)
        }}
        isLoading={isLoading}
        buttonText={t("Delete")}
        bodyTitle={t("Are you sure you want to delete this Catering?")}
      /> */}
    </>
  )
}

export default ExportsDatatable
